export default __webpack_public_path__ + "static/form-builder-a2614a72709b95eeec5825696370adbd.png";